/**
 * Even patch numbers (and x.y.0) force the frontend to reload. A client has to reload whenever ANY such
 * version was released between its own version and the backend version - not only if the backend version
 * itself is a forcing one (e.g. 2.4.2 -> 2.5.3 skipped the forcing 2.5.0 and must reload nevertheless).
 */
export function requiresForcedReload(clientVersion: string, backendVersion: string): boolean {
  const [clientMajor, clientMinor, clientPatch] = clientVersion.split(".").map((x) => Number.parseInt(x));
  const [backendMajor, backendMinor, backendPatch] = backendVersion.split(".").map((x) => Number.parseInt(x));
  if ([clientMajor, clientMinor, clientPatch, backendMajor, backendMinor, backendPatch].some((x) => Number.isNaN(x)))
    return clientVersion !== backendVersion;
  if (clientMajor !== backendMajor || clientMinor !== backendMinor) return true;
  return Math.floor(backendPatch / 2) > Math.floor(clientPatch / 2);
}
